<template>
    <div id="conteudo">
        <i @click="backToTop()" class="back-to-top icon-cr icon-arrow-right"></i>
        <div class="banner-container pb-5">
            <div class="image-top text-center">
                <picture>
                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei.png?auto=compress,format&q=65`"
                        media="(min-width: 1366px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei.png?auto=compress,format&q=65`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65`"
                        media="(min-width: 1065px) and (max-width: 1365px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=1065&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 900px) and (max-width: 1064px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=1065&h=1062&fit=crop&crop=entropy`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=900&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 768px) and (max-width: 900px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=900&h=1062&fit=crop&crop=entropy`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=767&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 576px) and (max-width: 767px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=767&h=1062&fit=crop&crop=entropy`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=576&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 501px) and (max-width: 576px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=576&h=1062&fit=crop&crop=entropy`"
                    />

                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=500&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 434px) and (max-width: 500px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=500&h=1062&fit=crop&crop=entropy`"
                    />
                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=433&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 376px) and (max-width: 433px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=433&h=1062&fit=crop&crop=entropy`"
                    />
                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=385&h=1062&fit=crop&crop=entropy`"
                        media="(min-width: 1px) and (max-width: 385px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65&w=385&h=1062&fit=crop&crop=entropy`"
                    />

                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/de-minas-para-o-mundo-chico-rei-origin.png?auto=compress,format&q=65`"
                        class="img-responsive"
                        style="width: 100%"
                        alt="Sustentabilidade"
                        src=""
                    />
                </picture>
            </div>
            <div class="banner-left-top">
                <a href="/">
                    <div class="header-logo-cr logo-cr-circle" title="Chico Rei"></div>
                </a>
                <a href="/">
                    <div class="header-logo-cr logo-cr-text" title="Chico Rei"></div>
                </a>
            </div>

            <div class="banner-right-top d-flex flex-align-center pos-fixed">
                <OriginsMenu @scroll-to="scrollToAnchor($event)" :menu-links="menuLinks" />
            </div>
            <div class="banner-center">
                <div class="content">
                    <h1 class="text-bold text-uppercase h2">
                        Transformamos singular em plural. Manifestamos ideias.
                    </h1>
                    <p>
                        Inquietos por natureza, acreditamos na liberdade individual e temos o
                        objetivo de dar possibilidades para pessoas interessantes se expressarem.
                        Investimos na diversidade para dialogar com as mais variadas tribos. Nosso
                        objetivo é fazer com que a arte pule dos objetos e seja a conexão, que ela
                        inicie diálogos e inspire o ciclo de criatividade.
                    </p>
                </div>
            </div>
        </div>

        <div class="content">
            <div id="mais-que-camisetas">
                <h2 class="text-bold text-uppercase" id="first-anchor">Mais que camisetas</h2>
                <p>
                    Nossa razão de existir, aquela que nos faz ter borboletas no estômago,<strong>
                        é usar a criatividade para impactar positivamente a vida das
                        pessoas.</strong
                    >
                    Por aqui acreditamos um bocado na força do que fazemos, e isso vai muito além
                    das camisetas.
                </p>
                <p>
                    Fomentamos relações de trabalho justas e transparentes, oferecendo a melhora da
                    autoestima através da criatividade, porque
                    <strong>acreditamos nas pessoas.</strong> Nos obrigamos a adotar práticas
                    contínuas de otimização e limpeza de processos, com matéria-prima sustentável e
                    vegana, porque acreditamos no planeta.
                </p>
                <p>
                    Colocamos o usuário como centro do negócio, numa busca constante por entregar
                    <strong>experiências pautadas pela excelência</strong> , porque acreditamos na
                    inventividade e na autoexpressão. Temos um pé fincado cá em Minas, mas uma
                    vontade danada de ganhar cada vez mais o horizonte.
                </p>
            </div>

            <div id="de-minas-para-todo-canto">
                <h3 class="text-bold text-uppercase">De Minas para todo canto</h3>
                <p>
                    Minas Gerais é uma mistura batuta de música, montanhas, clima, arquitetura,
                    pessoas, sotaques e sabores.<strong>
                        Minas é muito mais que divisão territorial: é o nosso estado de
                        espírito!</strong
                    >
                </p>
                <p>
                    Temos orgulho dessa terra fértil de boas ideias, por isso gritamos para o mundo
                    em prosa e poesia numa ode constante a esse mar de morros: é desses contornos
                    que tiramos nossa inspiração; sem Minas, não tem Chico Rei!
                </p>

                <div
                    class="d-flex flex-align-center flex-justify-center flex-wrap mb-5 hidden-lg-down"
                >
                    <div v-for="url in line_images1" class="mr-1">
                        <img alt="Chico Rei" :src="url" />
                    </div>
                    <div v-for="url in line_images2" class="mr-1">
                        <img alt="Chico Rei" :src="url" />
                    </div>
                    <div v-for="url in line_images3" class="mr-1">
                        <img alt="Chico Rei" :src="url" />
                    </div>
                </div>

                <div
                    class="d-flex flex-align-center flex-justify-center flex-wrap mb-5 hidden-lg-up"
                >
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/site/2023/quem-somos/sobre-a-chico-rei.png?auto=compress,format&q=65`"
                        alt="Sobre a Chico Rei"
                        class="img-responsive"
                    />
                </div>

                <h4 class="text-bold text-uppercase">
                    Nascemos nos corredores da faculdade de artes
                </h4>

                <p>
                    A marca foi criada por Bruno Imbrizi, nos corredores da Faculdade de Artes da
                    Universidade Federal de Juiz de Fora, lá em 2008. Materializar uma marca era
                    <strong
                        >uma forma de liberdade de expressão, de construção de novos caminhos e de
                        narrar a relação com Minas Gerais através do que se vestia </strong
                    >. O olhar de admiração pelas mãos que fabricavam as peças foi construído desde
                    a infância, o cheiro de malha era lugar comum, desenvolver uma marca de arte e
                    moda foi caminho natural nessa história.
                </p>

                <p>
                    Narrando a relação com Minas Gerais, também encontramos a história de
                    <strong>Chico Rei, figura lendária do povo mineiro</strong>, que então batiza o
                    nome da marca com o que de melhor a história de Chico Rei carrega:
                    <strong>busca por liberdade, relações coletivas e orgulho de sua terra</strong>
                    . As festas de Reisado e Congado foram as primeiras formas de levar as cores da
                    nossa terra para outro cantos.
                </p>

                <p>
                    Entre os primeiros rabiscos e hoje há um espaço e tanto de tempo e estrada.
                    Nessa caminhada, encontramos um bocado de gente que se identificou com as nossas
                    ideias. Mais do que isso, se sentiu representado pela forma como elas
                    <strong>permitem se expressar para o mundo.</strong>
                </p>

                <p>
                    Nos tornamos
                    <strong>referência nacional quando o assunto é criatividade</strong>
                    e multiplicamos o nosso modelo de negócio em braços que levam a nossa
                    assinatura, tipo tatuagem.
                </p>

                <p>
                    Saímos da internet e ganhamos o espaço físico através de
                    <strong>lojas parceiras</strong>. Em seguida, levamos nosso sambalelê para lojas
                    próprias. Abrimos as portas para empresas bacanas em vendas corporativas, com
                    qualidade e excelência.
                </p>

                <p>
                    Hoje a Chico Rei é parte de um grupo de empresas que bebem da mesma fonte de
                    <strong>inventividade, coletividade e irreverência</strong>. A marca que nasceu
                    num quarto não é mais a mesma, mas os estalos que foram faísca para as primeiras
                    ideias seguem firmes por aqui.
                </p>

                <div id="video-player" class="text-center my-5 py-3">
                    <iframe
                        width="100%"
                        src="https://www.youtube.com/embed/AXhmaYtl4ec"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer;
                        autoplay;
                        clipboard-write;
                        encrypted-media;
                        gyroscope;
                        picture-in-picture;
                        web-share"
                        allowfullscreen
                    >
                    </iframe>
                </div>

                <div id="no-que-acreditamos">
                    <h2 class="text-bold text-uppercase" id="second-anchor">No que acreditamos</h2>
                    <div class="d-flex">
                        <div class="colorful-bar"></div>
                        <div class="topics">
                            <h5 class="text-bold text-uppercase">
                                Acreditamos no poder da criatividade
                            </h5>
                            <p>
                                Existimos para impactar positivamente a vida das pessoas através de
                                auto-expressão, auto-estima e conforto. Materializamos ideias que
                                transmitem um estilo de vida permeado pela busca constante pelo
                                novo. Somos inquietos por natureza, por isso criamos o tempo todo.
                                Através da criatividade, transformamos ideias em produtos e produtos
                                em impacto positivo.
                            </p>

                            <h5 class="text-bold text-uppercase">
                                Acreditamos que todos podem se vestir como quiserem
                            </h5>
                            <p>
                                A Chico Rei nasceu da necessidade de vestir aquilo que gostaríamos,
                                mas que não encontrávamos por aí. Entendemos a camiseta como uma
                                tela em branco, uma forma de externar um pouco da nossa
                                personalidade e nos conectar com o mundo. Acreditamos na liberdade
                                de estar confortável consigo mesmo. Temos o objetivo de dar
                                possibilidades para pessoas interessantes se expressarem.
                            </p>

                            <h5 class="text-bold text-uppercase">
                                Acreditamos em agregar, nunca excluir
                            </h5>
                            <p>
                                Nos encontramos no coletivo e nos entendemos como parte de uma
                                comunidade. Nossos produtos são, essencialmente, iniciadores de
                                conversas e como bons mineiros, não abrimos mão de um dedo de prosa.
                                O auge da nossa alegria é ver um tanto de gente bacana usando as
                                nossas criações. Para isso, buscamos oferecer produtos acessíveis e
                                inclusivos: quanto mais gente usando, melhor. Deixamos a
                                “exclusividade” apenas para as nossas criações, porque a ideia aqui
                                é somar e agregar, sempre.
                            </p>

                            <h5 class="text-bold text-uppercase">Defendemos a diversidade</h5>
                            <p>
                                A Chico Rei existe para pessoas e é feita por elas. Acreditamos que
                                a arte transforma, ressignifica e constrói pontes. Defendemos a
                                diversidade, porque só faz sentido quando tá bacana pra todo mundo.
                                Para nós, todo conhecimento, expertise, conquistas e recursos são
                                ferramentas que devem ser usadas para empoderar e erguer as pessoas.
                                Abraçamos a luta pelo respeito às escolhas e histórias do outro:
                                nosso desejo é que todos possam se vestir do que são, sem temer.
                            </p>

                            <h5 class="text-bold text-uppercase">
                                Acreditamos no senso do coletivo
                            </h5>
                            <p>
                                E por isso, que todos devem cumprir o seu papel para um mundo mais
                                bacana. Como parte da indústria da moda, nos obrigamos a adotar
                                práticas contínuas de otimização e limpeza de processos. Não podemos
                                salvar o planeta, mas temos uma série de atitudes que podem ser
                                feitas com o objetivo de amenizar o lastro de nossas ações. Fazemos
                                bastante coisa, mas consideramos o mínimo para que a nossa passagem
                                pelo mundo não tenha um histórico negativo de degradação.
                            </p>

                            <h5 class="text-bold text-uppercase">
                                Defendemos uma comunicação transparente
                            </h5>
                            <p>
                                Tudo o que fazemos é pautado por verdade. Muito antes de falar,
                                procuramos fazer um trabalho sólido que dê sustentação aos nossos
                                discursos. É isso o que movimenta a nossa paixão. E como diria
                                Nelson Rodrigues, "sem paixão não dá nem pra chupar um picolé".
                                Fomentamos relações de trabalho justas e transparentes, pontuadas
                                por carinho e responsabilidade. Chico Rei é a luta por liberdade em
                                sua essência: liberdade de expressão, diversidade,
                                representatividade e tecelagem de laços entre indivíduos.
                            </p>
                        </div>
                    </div>
                </div>

                <div id="tamo-em-todas">
                    <h2 id="third-anchor" class="text-bold text-uppercase pt-5 mb-3">
                        Tamo em todas
                    </h2>
                    <div class="d-flex flex-wrap">
                        <div class="img-tamo hidden-sm-down">
                            <img
                                class="img-responsive"
                                alt="Tamo em Todas"
                                :src="this.tamo_em_todas_img"
                            />
                        </div>
                        <div class="about-work">
                            <p>
                                A gente gosta de falar, mas adora mesmo é um diálogo! Selecionamos
                                algumas matérias bacanas sobre o nosso trabalho:
                            </p>

                            <p>
                                <a
                                    href="https://www.uol.com.br/ecoa/ultimas-noticias/2021/01/13/chico-rei-quer-tirar-o-estigma-de-presidiarios-por-meio-do-trabalho.htm"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>UOL ECOA</strong></u
                                    ><br />
                                    Chico Rei quer tirar o estigma de presidiários por meio do
                                    trabalho.
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://www.projetodraft.com/a-chico-rei-comecou-na-casa-do-fundador-hoje-fatura-milhoes-vendendo-camisetas-e-destina-uma-porcentagem-a-projetos-sociais/"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>PROJETO DRAFT</strong></u
                                    ><br />
                                    A Chico Rei começou na casa do fundador...
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://revistapegn.globo.com/Banco-de-ideias/Moda/noticia/2021/01/empreendedor-fatura-r-20-milhoes-com-negocio-de-camisetas-estampadas.html"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>PEQUENAS EMPRESAS GRANDES EMPRESAS</strong></u
                                    ><br />
                                    Chico Rei se destaca por camisetas personalizadas de temas
                                    referentes a brasilidades, cinema, música e séries.
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://oglobo.globo.com/blogs/blog-clube-o-globo/post/2022/09/de-minas-para-o-mundo.ghtml"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>O GLOBO</strong></u
                                    ><br />
                                    De Minas para o Mundo
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://www.estadao.com.br/economia/cidades-do-interior-ganham-destaque-em-ranking-de-empreendedorismo/"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>ESTADÃO</strong></u
                                    ><br />
                                    Cidades do interior ganham destaque em ranking de
                                    empreendedorismo
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://razoesparaacreditar.com/detentos-poupanca-ajuda-familias-camisetas/"
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <u><strong>RAZÕES PARA ACREDITAR</strong></u
                                    ><br />
                                    Detentos diminuem pena e garantem assistência ás famílias
                                    produzindo camisetas (MG)
                                </a>
                            </p>
                        </div>

                        <div class="img-tamo hidden-sm-up">
                            <img
                                class="img-responsive"
                                alt="Tamo em Todas"
                                style="margin: 0 auto"
                                :src="this.tamo_em_todas_img"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line" />

        <div
            id="links"
            class="content d-flex flex-justify-around flex-align-center text-uppercase flex-wrap links-footer-orign"
        >
            <a href="/sustentabilidade" target="_blank">Sustentabilidade</a>
            <a href="/nossas-lojas" target="_blank">Nossas Lojas</a>
            <a href="/trabalhe-conosco" target="_blank">Trabalhe aqui</a>
        </div>
    </div>
</template>

<script>
    import OriginsMenu from './OriginsMenu.vue';

    export default {
        name: 'Origins',

        components: {
            OriginsMenu,
        },

        el: '#origins-vue',

        data() {
            return {
                banner_img:
                    this.$scope.CDN_IMAGES +
                    '/images/site/2023/quem-somos/banner-image.png?auto=compress,format&q=65',
                banner_img_mobile:
                    this.$scope.CDN_IMAGES +
                    '/images/site/2023/quem-somos/bg-sobre-a-chico.png?auto=compress,format&q=65',
                tamo_em_todas_img:
                    this.$scope.CDN_IMAGES +
                    '/images/site/2023/quem-somos/tamo_em_todas.png?auto=compress,format&q=65',

                line_images1: [
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image01.png?auto=compress,format&q=65',
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image02.png?auto=compress,format&q=65',
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image03.png?auto=compress,format&q=65',
                ],

                line_images2: [
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image04.png?auto=compress,format&q=65',
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image05.png?auto=compress,format&q=65',
                ],

                line_images3: [
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image06.png?auto=compress,format&q=65',
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image07.png?auto=compress,format&q=65',
                    this.$scope.CDN_IMAGES +
                        '/images/site/2023/quem-somos/image08.png?auto=compress,format&q=65',
                ],

                menuLinks: [
                    {
                        name: 'Mais Que Camisetas',
                        anchor: 'first-anchor',
                    },
                    {
                        name: 'No Que Acreditamos',
                        anchor: 'second-anchor',
                    },
                    {
                        name: 'Tamo Em Todas',
                        anchor: 'third-anchor',
                    },
                ],
            };
        },

        methods: {
            backToTop() {
                cr$.byId('my-wrapper').scrollIntoView();
            },

            scrollToAnchor(anchor) {
                cr$.byId(anchor).scrollIntoView();
            },
        },
    };
</script>
